import Reveal from "@/components/base/Reveal";

export default function GroupHP() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <Reveal>
          <div className="flex flex-col items-center gap-6 rounded-lg border border-background-200 bg-background-100 p-8 text-center md:p-12">
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-accent-600">
              Parceria estratégica
            </p>
            <h2 className="max-w-3xl font-heading text-3xl font-extrabold tracking-tight text-foreground-950 md:text-4xl">
              Mais conhecimento e soluções para atender as necessidades da indústria.
            </h2>

            <div className="flex flex-col items-center gap-4 sm:flex-row sm:gap-8">
              <span className="font-heading text-2xl font-extrabold text-primary-700">
                POWER
              </span>
              <span className="text-2xl font-bold text-foreground-400">+</span>
              <span className="font-heading text-2xl font-extrabold text-foreground-900">
                GRUPO HP ELETROMECÂNICA
              </span>
            </div>

            <p className="max-w-2xl text-base leading-relaxed text-foreground-600">
              Relação comercial estratégica que amplia o acesso a conhecimento técnico e
              soluções em manutenção eletromecânica, motores elétricos, bombas, redutores e
              automação industrial.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}